import React, { Component, useState, Fragment } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import TableBilling from "./table";
import { transactionBilling } from "../../../utilities/Const/TranscationCode";
import LabelBilling from "../../../utilities/Status/billing";
import FormBill from "../../../../containers/modules/sales/billing/form-bill";
import FormPay from "../../../../containers/modules/sales/billing/form-pay";
const MySwal = withReactContent(Swal);
export class BillingIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      titleModal: "",
      modal: 1,
      listData: [],

      column: [
        {
          key: "transaction_no",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Billing No."),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "date_format",
          filter: { active: true, type: "Date", data: null },
          title: i18n.t("Date"),
          type: "text",
          tHclass: "min-w-100px",
          tdClass: "",
        },
        {
          key: "branch_name",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Branch"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "sales_name",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Sales Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "status",
          filter: {
            active: true,
            type: "Select",
            data: transactionBilling,
          },
          title: i18n.t("Status"),
          type: "component",
          tHclass: "min-w-125px",
          tdClass: "",
          component: (data, column) => {
            return <LabelBilling value={data[column.key]} />;
          },
        },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "id",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-150px",
          tdClass: "text-center",
          form:'icon',
          buttons: [
            {
              key: "id",
              btnText: i18n.t("Payment"),
              visible: {
                key: "status",
                params: [1],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.paymentData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Edit"),
              visible: {
                key: "status",
                params: [1],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.updateData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Close"),
              visible: {
                key: "status",
                params: [1],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.closingData(data);
              },
              bthClass: "btn btn-danger",
            },
            
          ],
          // component: (data, column) => {
          //   return (
          //     <Fragment>
          //       <Dropdown id="dropdown-btnaction">
          //         <Dropdown.Toggle
          //           variant="none"
          //           className="btn btn-sm btn-light btn-active-light-primary"
          //           id="dropdown-basic"
          //         >
          //           {<FontAwesomeIcon icon={faEllipsis}></FontAwesomeIcon>}
          //         </Dropdown.Toggle>
          //         <Dropdown.Menu className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4 m-0">
          //           {data.status == 1 ? (
          //             <>
          //               <div className="menu-item px-3">
          //                 <Dropdown.Item
          //                   href="#"
          //                   className="menu-link px-3"
          //                   onClick={() => this.paymentData(data.id)}
          //                 >
          //                   {i18n.t("Payment")}
          //                 </Dropdown.Item>
          //               </div>
          //             </>
          //           ) : null}
          //           {data.status == 1 ? (
          //             <>
          //               <div className="menu-item px-3">
          //                 <Dropdown.Item
          //                   href="#"
          //                   className="menu-link px-3"
          //                   onClick={() => this.updateData(data.id)}
          //                 >
          //                   {i18n.t("Edit")}
          //                 </Dropdown.Item>
          //               </div>
          //             </>) : null}
          //           {data.status == 1 ? (
          //             <>
          //               <div className="menu-item px-3">
          //                 <Dropdown.Item
          //                   href="#"
          //                   className="menu-link px-3"
          //                   onClick={() => this.closingData(data.id)}
          //                 >
          //                   {i18n.t("Close")}
          //                 </Dropdown.Item>
          //               </div>
          //             </>) : null}


          //           {/* </>
          //           ) : null} */}
          //           {/* {data.status == 5 ? ( */}
          //           {/* <Fragment>
          //             <div className="menu-item px-3">
          //               <Dropdown.Item
          //                 href={"/purchasing/purchase-order/print/" + data.id}
          //                 className="menu-link px-3"
          //                 target={"_blank"}
          //               >
          //                 {i18n.t("Print")}
          //               </Dropdown.Item>
          //             </div>
          //             <div className="menu-item px-3">
          //             <Dropdown.Item
          //               href="#"
          //               className="menu-link px-3"
          //               onClick={() => this.closingData(data.id)}
          //             >
          //               {i18n.t("Close")}
          //             </Dropdown.Item>
          //           </div>
          //           </Fragment> */}
          //           {/* ) : null} */}
          //         </Dropdown.Menu>
          //       </Dropdown>
          //     </Fragment>
          //   );
          // },
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.createData = this.createData.bind(this);
    this.closingData = this.closingData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.titleModal = i18n.t("Add Billing");
    this.props.create();
    this.state.modal = 1;

  }
  updateData(id) {
    this.state.titleModal = i18n.t("Update Billing");
    this.props.update(id);
    this.state.modal = 1;
  }
  paymentData(id) {
    this.state.titleModal = i18n.t("Payment Billing");
    this.props.payment(id);
    this.state.modal = 2;
  }

  alertError(title, message, icon) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }

  rejectData(id) {
    const html = (
      <>
        <div>{i18n.t("Reject This PO")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            MySwal.fire({
              title: i18n.t("Enter your message"),
              icon: false,
              input: "textarea",
              inputValue: "",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  return i18n.t("You need to write something!");
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const value = result.value;
                MySwal.fire({
                  title: i18n.t("Proccessing Data"),
                  html: i18n.t("Please Wait ...."),
                  icon: "info",
                });
                MySwal.showLoading();
                this.props.rejectItem(id, value, this.state.search);
              }
            });
          }}
        >
          {i18n.t("Reject")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  deleteData(id) {
    const html = (
      <>
        <div>{i18n.t("You will delete this Item")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.deleteItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Deleting Data"),
              html: i18n.t("Please Wait ...."),
              icon: "info",
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Delete")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  closingData(id) {
    const html = (
      <>
        <div>{i18n.t("You will Closing this Billing")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.closingItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Process Data"),
              html: i18n.t("Please Wait ...."),
              icon: "info",
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Confirm")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  render() {
    const { isProcessing, data, showModal, showModalBilling } = this.props;
    this.state.listData = data;
    return (
      <div id="customer-type">
         <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-fluid">
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 ">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                  <Button
                    type="button"
                    className="btn btn-warning m-1"
                    onClick={(e) => this.runSearch(this.state.search)}
                  >
                    <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                  </Button>
                  <Button
                    type="button"
                    className="btn btn-primary m-1"
                    onClick={(e) => this.createData()}
                  >
                    {i18n.t("Add Billing")}
                  </Button>
                </div>
              </div>
            </div>
            <div className="card-body pt-0">
              <TableBilling
                checkAble={false}
                numberAble={true}
                expandAble={true}
                theExpand={{
                  key: "billing_detail",
                  columns: [
                    { label: i18n.t("Invoice No."), key: "invoice_no" },
                    { label: i18n.t("Customer Name"), key: "customer_name" },
                    { label: i18n.t("Total Invoice"), key: "total_format" },
                    { label: i18n.t("Payment Type"), key: "payment_type" },
                    { label: i18n.t("Payment"), key: "payment_format" },
                    { label: i18n.t("Remaining Payment"), key: "remaining_payment_format" },
                  ],
                }}
                data={this.state.listData}
                tools={false}
                filterSearch={true}
                column={this.state.column}
                searchData={this.state.search}
                runSearch={this.runSearch}
                deleteData={this.deleteData}
                updateData={this.updateData}
                isProcessing={isProcessing}
              />
            </div>
          </div>

        </div>
        {this.state.modal == 1 ?
          <FormBill
            showModalBilling={showModalBilling}
            search={this.state.search}
            titleModal={this.state.titleModal}
          />
          :
          <FormPay
            showModal={showModal}
            search={this.state.search}
            titleModal={this.state.titleModal}
          />

        }
      </div>
    </div>
    );
  }
}

export default BillingIndex;
